module.exports = __webpack_public_path__ + "img/twistie-down.b9d20f87.svg";